// extracted by mini-css-extract-plugin
module.exports = {"input":"Annulment_input__4V3mp","button":"Annulment_button__BEvat"};